export default "__VITE_ASSET__862cee4c__"